/**
 * BookList - Calil 検索結果の本カードリスト
 *
 * 展開中の本カードのみ所蔵館一覧を表示する。複数同時に展開可能。
 * 図書館フィルタは書誌の表示/非表示には影響せず、BookCard 側で「選択館のみ表示」制御を行う。
 * (選択館に該当所蔵が 0 件の書誌については、BookCard 側でフォールバックで全館表示する)
 */

import type { CalilBook } from '@/api/types/calil'

import { BookCard } from './BookCard'

type Props = {
  books: CalilBook[]
  expandedBookIds: ReadonlySet<string>
  onToggle: (bookId: string) => void
  /** カード表示モード (デフォルト: search)。favorite 時は状態遷移ボタンが有効になる。 */
  mode?: 'search' | 'favorite'
}

export const BookList = ({ books, expandedBookIds, onToggle, mode = 'search' }: Props) => {
  if (books.length === 0) return null
  return (
    <div className="flex flex-col gap-2">
      {books.map((book) => (
        <BookCard
          key={book.id}
          book={book}
          expanded={expandedBookIds.has(book.id)}
          onToggle={() => onToggle(book.id)}
          mode={mode}
        />
      ))}
    </div>
  )
}
